 <template>
  <el-dialog title="出入库记录查询" :visible.sync="visible" width="1200px" @close="handleClose">
    <el-form :model="searchForm" ref="searchForm" label-width="80px">
      <div class="form-row">
        <el-form-item label="查询时间" prop="operateDate" class="form-item date-range-item">
          <el-date-picker
            style="width: 100%"
            v-model="searchForm.operateDate"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
        <el-form-item label="库区名称" prop="oilDepotCode" class="form-item">
          <el-select v-model="searchForm.oilDepotCode" style="width: 100%">
            <el-option
              v-for="item in oilDepotOptions"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="油罐编码" prop="oilTankCode" class="form-item">
          <el-select v-model="searchForm.oilTankCode" filterable clearable style="width: 100%">
            <el-option v-for="item in oilTankOptions" :key="item.oilTankCode" :label="item.oilTankCode" :value="item.oilTankCode"/>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">查询</el-button>
        <el-button type="primary" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" style="width: 100%" tooltip-effect="light" v-loading="loading">
      <el-table-column prop="companyName" label="企业名称" :show-overflow-tooltip="true" />
      <el-table-column prop="agreementNo" label="协议编号" :show-overflow-tooltip="true" />
      <el-table-column prop="businessTypeName" label="业务类型" :show-overflow-tooltip="true" />
      <el-table-column prop="itemName" label="物料名称" :show-overflow-tooltip="true" />
      <el-table-column prop="itemCode" label="物料编码" :show-overflow-tooltip="true" />
      <el-table-column prop="reservoirAreaName" label="库区名称" :show-overflow-tooltip="true" />
      <el-table-column prop="oilTankCode" label="罐号" :show-overflow-tooltip="true" />
      <el-table-column prop="transportCarNo" label="车号" :show-overflow-tooltip="true" />
      <el-table-column prop="primaryNum" label="实发量" :show-overflow-tooltip="true" />
      <el-table-column prop="outFactoryTime" label="出库时间" :show-overflow-tooltip="true" />
      <el-table-column prop="realityNum" label="实收量" :show-overflow-tooltip="true" />
      <el-table-column prop="inStorageTime" label="入库时间" :show-overflow-tooltip="true" />
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      background
    />
    <el-row class="export-row"
            type="flex"
            justify="end">
      <el-button type="primary"
                 @click="handleExportCSV">导出为CSV文件</el-button>
    </el-row>
  </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import HttpUtil from '@/common/HttpUtil'

export default {
  name: 'addOrEditDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      visible: false,
      searchForm: {
        operateDate: '',
        oilDepotCode: '',
        oilTankCode: ''
      },
      oilDepotOptions: [
        { code: 'PJPSK', name: '盘锦盘山油库' },
        { code: 'JHK', name: '天津静海油库' },
        { code: 'CMK', name: '山西昌茂油库' }
      ],
      oilTankOptions: [],
      tableData: [],
      listState: {
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      loading: false
    }
  },
  mounted () {
    this.getDicOilTankList({ reservoirAreaCode: 'XNYYPK' }).then((res) => {
      if (res) {
        this.oilTankOptions = res.map((item) => {
          return {
            oilTankCode: item.oilTankCode,
            oilTankName: item.oilTankName
          }
        })
      }
    })
  },
  methods: {
    ...mapActions([
      'getDicOilTankList'
    ]),
    reset () {
      this.searchForm = {
        operateDate: '',
        oilDepotCode: '',
        oilTankCode: ''
      }
      this.tableData = []
      this.listState = {
        pageSize: 10,
        pageNo: 1,
        total: 0
      }
    },
    handleSearch () {
      this.page()
    },
    page (pageNo, pageSize) {
      this.loading = true
      const params = this.buildQueryParams(pageNo, pageSize)
      HttpUtil.post('manage/lifonda/inventoryRecord/business/page', params)
        .then((res) => {
          if (res && res.data) {
            const { list, total, pageNum, pageSize } = res.data
            this.tableData = list
            this.listState.total = total
            this.listState.pageNo = pageNum
            this.listState.pageSize = pageSize
          }
        })
        .catch((error) => {
          console.error('获取业务记录失败:', error)
          this.$message.error('获取业务记录失败，请重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSizeChange (size) {
      this.listState.pageSize = size
      this.page(1, size)
    },
    handleCurrentChange (current) {
      this.listState.pageNo = current
      this.page(current, this.listState.pageSize)
    },
    handleClose () {
      this.$emit('update:show', false)
    },
    buildQueryParams (pageNo, pageSize) {
      return {
        reservoirAreaType: 'XNYYPK',
        reservoirAreaCode: this.searchForm.oilDepotCode,
        oilTankCode: this.searchForm.oilTankCode,
        timeStart: this.searchForm.operateDate && this.searchForm.operateDate[0],
        timeEnd: this.searchForm.operateDate && this.searchForm.operateDate[1],
        pageNo: pageNo || this.listState.pageNo,
        pageSize: pageSize || this.listState.pageSize
      }
    },
    exportData () {
      const params = this.buildQueryParams()
      return HttpUtil.post('manage/lifonda/inventoryRecord/business/page/export', params, { responseType: 'blob' })
    },
    handleExportCSV () {
      if (!Array.isArray(this.tableData) || this.tableData.length === 0) {
        this.$message({
          message: '暂无数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.loading = true
        this.exportData().then((res) => {
          const createDownloadFile = () => {
            const blob = new Blob([res])
            const link = document.createElement('a')
            link.download = '出入库记录.xls'
            link.style.display = 'none'
            link.target = '_Blank'
            link.href = window.URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
            document.body.removeChild(link)
          }
          createDownloadFile()
          this.$message.success('导出成功')
        }).catch((error) => {
          console.error('导出失败:', error)
          this.$message.error('导出失败，请重试')
        }).finally(() => {
          this.loading = false
        })
      }).catch(() => {})
    }
  },
  watch: {
    show: {
      handler (newVal) {
        this.visible = newVal
      },
      immediate: true
    }
  }
}
</script>
<style lang="scss" scoped>
.pagination {
  margin-top: 15px;
  text-align: right;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
  align-items: flex-end;
}

.form-item {
  flex: 1;
  min-width: 200px;
  margin-right: 20px;
}

// 增加日期选择器的宽度
.date-range-item {
  flex: 2;
  min-width: 400px;
}

.form-item:last-child {
  margin-right: 0;
}

// 调整表单项宽度以适应一行显示
.form-item .el-form-item {
  margin-bottom: 0;
}

// 调整日期选择器宽度
.el-date-editor {
  width: 100% !important;
}

// 确保选择器宽度为100%
.el-select {
  width: 100% !important;
}

.export-row {
  margin-top: 15px;
}
</style>
